var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('iframe',{style:({
      height: 'fit-content',
      maxHeight: '100vh',
      height: 'calc(100vh - 219px)',
    }),attrs:{"src":_vm.cpxURL}})])}
var staticRenderFns = []

export { render, staticRenderFns }